"use strict";
/**
 * Type definitions for OAuth proxy (Xero OAuth forwarding)
 */
Object.defineProperty(exports, "__esModule", { value: true });
